import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

/** UAE time for display; everything is stored in UTC. */
const dt = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Dubai',
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
});
const tm = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Dubai', hour: '2-digit', minute: '2-digit', hour12: true });
/** 12-hour clock with upper-case AM / PM (en-GB writes "pm"). */
const ampm = (s: string) => s.replace(/\s*([ap])\.?m\.?$/i, (_, x: string) => ` ${x.toUpperCase()}M`).replace(/^0?0:/, '12:');
const d = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Dubai', day: '2-digit', month: 'short', year: 'numeric' });

export const formatDateTime = (iso: string | null | undefined) => (iso ? ampm(dt.format(new Date(iso))) : '—');
/** UAE time of day, e.g. 03:45 PM. */
export const formatTime = (iso: string | null | undefined) => (iso ? ampm(tm.format(new Date(iso))) : '—');
export { clock12 } from '@ruby/shared';
export const formatDate = (iso: string | null | undefined) => (iso ? d.format(new Date(iso)) : '—');

const aed = new Intl.NumberFormat('en-AE', { style: 'currency', currency: 'AED', minimumFractionDigits: 2 });
export const formatAED = (n: number) => aed.format(n);

export const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join('');

export const newIdempotencyKey = () => crypto.randomUUID();
